<template>
  <CHeader with-subheader class="fixed-top role-theme-header">
    <CToggler in-header class="role-header-toggle ml-2 header-toggle-hidden" @click="$store.commit('toggleUnifiedSidebar')"/>

    <CHeaderBrand class="header-brand-hidden" :to="navRole === 'student_affairs' ? '/student-affairs' : '/supervisor'">
      <div class="d-flex align-items-center">
        <img class="logo-custom pr-2 py-1" src="@/assets/logo.svg">
        <div class="text-black">
          <p class="font-weight-bold mb-0 brand-title">MFU</p>
          <p class="font-weight-bold mb-0 brand-subtitle">{{ $t('brand.maintenanceShort') }}</p>
        </div>
      </div>
    </CHeaderBrand>

    <div class="desktop-system-title">{{ $t('login.title') }} <span>{{ $t('login.subtitle') }}</span></div>
    <RoleDesktopTopNav :role="navRole" />

    <CHeaderNav class="d-flex align-items-center ml-auto pr-2 flex-nowrap user-profile-nav">
      <NotificationDropdown class="mr-2 flex-shrink-0" />
      <LanguageSwitcher class="mr-2 flex-shrink-0" />
      <TheHeaderDropdownAccnt class="pr-1 pr-md-3 flex-shrink-0"/>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import LanguageSwitcher from '@/components/common/LanguageSwitcher.vue'
import RoleDesktopTopNav from '@/components/common/RoleDesktopTopNav.vue'
import NotificationDropdown from '@/components/common/NotificationDropdown.vue'
import { mapGetters } from "vuex";

export default {
  name: 'TheHeader',
  props: { navRole: { type: String, default: 'supervisor' } },
  components: { TheHeaderDropdownAccnt, LanguageSwitcher, RoleDesktopTopNav, NotificationDropdown },
  computed: { ...mapGetters("auth", ["profile", "role"]) },
  mounted() {
    if (this.$el && this.$el.parentNode !== document.body) document.body.appendChild(this.$el)
  },
  beforeDestroy() {
    if (this.$el && this.$el.parentNode === document.body) document.body.removeChild(this.$el)
  },
}
</script>

<style scoped>
.header-toggle-hidden, .header-brand-hidden { display: none !important; }
.desktop-system-title { display: flex; flex: 0 1 auto; flex-direction: column; justify-content: center; min-width: 0; max-width: 260px; margin-left: 14px; color: #1e40af; font-size: 14px; font-weight: 800; line-height: 1.2; white-space: nowrap; }
.desktop-system-title span { color: #64748b; font-size: 10px; font-weight: 600; }
@media (min-width: 1201px) {
  .desktop-system-title { min-width: 190px; max-width: 240px; margin-left: 16px; font-size: 15px; line-height: 1.25; }
  .desktop-system-title span { font-size: 11px; }
}
@media (max-width: 480px) {
  .desktop-system-title { flex: 1 1 auto; margin-left: 12px; font-size: clamp(14px, 4vw, 16px); line-height: 1.18; }
  .desktop-system-title span { margin-top: 2px; font-size: clamp(10px, 2.8vw, 11.5px); }
}
/* Desktop */
.logo-custom { height: 50px; width: auto; }

.brand-title { font-size: 1.25rem; }
.brand-subtitle { font-size: 1rem; }

.user-profile-nav {
  min-width: 0;
  flex-shrink: 1;
}

.my-text-style { 
  font-family: 'Sarabun', sans-serif;
  font-size: 14px;
  color: #333333;
  font-weight: bold;
  white-space: nowrap;
  text-align: right;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (min-width: 1400px) {
  .my-text-style {
    max-width: 230px;
    font-size: 15px;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .logo-custom { height: 35px; }
  .brand-title { font-size: 1rem; line-height: 1.2; }
  .profile-name-mobile {
    font-size: 11px;
    font-weight: bold;
    color: #333333;
    max-width: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

@media (max-width: 480px) {
  .brand-title { font-size: 0.9rem; }
}
</style>
